module.exports = __webpack_public_path__ + "img/S5.e8c636a6.png";